/* ==========================================================================
   Cura — Solution Tabs
   Panels are fully server-rendered; this script only switches visibility.
   That guarantees products ALWAYS match the selected tab — there is no
   fetching, no cache, no race condition to break.
   - Click / keyboard (← → Home End) tab switching, correct ARIA
   - Active tab auto-scrolls into view (mobile pill carousel)
   Editor-safe re-init on shopify:section:load.
   ========================================================================== */

(function () {
  'use strict';

  function initTabs(root) {
    if (root.dataset.cstInit === 'true') return;
    root.dataset.cstInit = 'true';

    var tabs = Array.from(root.querySelectorAll('[data-cst-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-cst-panel]'));
    var tablist = root.querySelector('[data-cst-tabs]');
    if (!tabs.length || !panels.length) return;

    function activate(index, focusTab) {
      tabs.forEach(function (tab) {
        var active = parseInt(tab.dataset.tabIndex, 10) === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active) {
          // keep the active pill visible in the mobile carousel
          tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          if (focusTab) tab.focus({ preventScroll: true });
        }
      });

      panels.forEach(function (panel) {
        var active = parseInt(panel.dataset.tabIndex, 10) === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(parseInt(tab.dataset.tabIndex, 10), false);
      });
    });

    // Keyboard navigation per WAI-ARIA tabs pattern
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var currentIdx = tabs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (currentIdx === -1) currentIdx = 0;
        var next = null;

        if (e.key === 'ArrowRight') next = (currentIdx + 1) % tabs.length;
        if (e.key === 'ArrowLeft')  next = (currentIdx - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home')       next = 0;
        if (e.key === 'End')        next = tabs.length - 1;

        if (next !== null) {
          e.preventDefault();
          activate(next, true);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cura-solution-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cura-solution-tabs]');
    if (root) {
      root.dataset.cstInit = 'false';
      initTabs(root);
    }
  });

  // In the theme editor, jump to a tab when its block is selected
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.matches && e.target.matches('[data-cst-tab]') ? e.target : null;
    if (tab) tab.click();
  });
})();